export const HeadphonesIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.83333 12.2917C5.83333 12.1766 5.74006 12.0833 5.625 12.0833H3.75V16.0417C3.75 16.1567 3.84327 16.25 3.95833 16.25H5.625C5.74006 16.25 5.83333 16.1567 5.83333 16.0417V12.2917ZM12.9167 16.0417V12.2917C12.9167 11.4862 13.5696 10.8333 14.375 10.8333H16.25V10C16.25 6.54822 13.4517 3.75 10 3.75C6.54822 3.75 3.75 6.54822 3.75 10V10.8333H5.625C6.4304 10.8333 7.08333 11.4862 7.08333 12.2917V16.0417C7.08333 16.8471 6.4304 17.5 5.625 17.5H3.95833C3.15293 17.5 2.5 16.8471 2.5 16.0417V10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10V16.0417C17.5 16.8471 16.8471 17.5 16.0417 17.5H14.375C13.5696 17.5 12.9167 16.8471 12.9167 16.0417ZM14.1667 16.0417C14.1667 16.1567 14.2599 16.25 14.375 16.25H16.0417C16.1567 16.25 16.25 16.1567 16.25 16.0417V12.0833H14.375C14.2599 12.0833 14.1667 12.1766 14.1667 12.2917V16.0417Z"
      fill="currentColor"
    />
  </svg>
);
